/* Leather Patch theme: mobile nav + Instagram scroller + cart count sync */
(function () {
  function init() {
    var header = document.querySelector('.lp-header');
    if (header) {
      var burger = header.querySelector('[data-lp-burger]');
      if (burger) {
        burger.addEventListener('click', function () {
          var open = header.classList.toggle('is-open');
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      header.querySelectorAll('[data-lp-drop-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (window.matchMedia('(max-width: 1000px)').matches) {
            e.preventDefault();
            btn.closest('.lp-nav__item').classList.toggle('is-open');
          }
        });
      });
      // Keep sticky offset variables used by the base theme in sync
      var h = header.offsetHeight;
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', h + 'px');
    }

    document.querySelectorAll('[data-lp-scroller]').forEach(function (wrap) {
      var track = wrap.querySelector('.lp-insta__track');
      if (!track) return;
      function step() { return Math.max(track.clientWidth * 0.8, 160); }
      var prev = wrap.querySelector('[data-lp-prev]');
      var next = wrap.querySelector('[data-lp-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });

    // Update the cart bubble when the base theme broadcasts a cart update
    document.addEventListener('cart:update', function (e) {
      var count = e && e.detail && e.detail.resource && e.detail.resource.item_count;
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-lp-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
